import type { Container } from "pixi.js";
import { aefiec } from "./aefiec.js";
import { aulas } from "./aulas.js";
import { coliseo } from "./coliseo.js";
import { contenedores } from "./contenedores.js";
import { decanato } from "./decanato.js";
import { fimcp } from "./fimcp.js";
import { iglooSceneFor } from "./igloo.js";
import { paradero } from "./paradero.js";
import { parque } from "./parque.js";
import { parqueo } from "./parqueo.js";
import { plazoleta } from "./plazoleta.js";
import { stem } from "./stem.js";
import { sweet } from "./sweet.js";
import { taller } from "./taller.js";
import { taws } from "./taws.js";
import { ubep } from "./ubep.js";

export type ProceduralScene = () => Container;

/**
 * Fallback art, keyed by `RoomDef.art`. A room with neither a background image in
 * the manifest nor an entry here still works — it just renders empty.
 */
export const PROCEDURAL_SCENES: Record<string, ProceduralScene> = {
  taws,
  plazoleta,
  sweet,
  aulas,
  fimcp,
  aefiec,
  decanato,
  parqueo,
  parque,
  stem,
  paradero,
  ubep,
  coliseo,
  contenedores,
  taller,
};

/**
 * El escenario de una clave de arte, venga de donde venga.
 *
 * Existe porque el iglú rompió el supuesto del registro de arriba: un escenario dejó de
 * ser "una función por sitio". Su clave lleva dentro el piso y la pared que eligió su
 * dueño (`igloo:madera:espol`), así que hay tantos escenarios como combinaciones y no
 * se pueden enumerar. Se resuelve preguntando, no buscando en un mapa.
 *
 * El orden importa: primero el catálogo fijo, que es el caso de las trece salas del
 * campus y no debería pagar por la excepción.
 */
export function proceduralScene(artKey: string): Container | null {
  const scene = PROCEDURAL_SCENES[artKey];
  if (scene) return scene();
  return iglooSceneFor(artKey);
}
